var exports = {
  "s": "SharedMarkdownContent__JRRdYK",
};

module.exports = exports;
